import { Component } from '@angular/core';
import { BaseComponentContext } from '../../../../modules/tcm-core.module';
import { BroadCastEvents } from '../../../../common/broad-cast-events.enum';
import { UpdatePatientPhotoRequest } from '../../../../models/patients';
import { PatientDataService } from '../../../../services/patient-data.service';

@Component({
    selector: 'update-photo',
    templateUrl: './update-photo.component.html',
    styleUrls: ['./update-photo.component.scss'],
    standalone: false
})
export class UpdatePhotoComponent {
    requestModel: any;

    isLoading: boolean;

    base64img: string;

    constructor(private componentContext: BaseComponentContext, private patientDataService: PatientDataService) {
    }

    goBack(data?: any) {
        this.componentContext.navService.navigateBack(data);
    }

    async save() {
        if (this.base64img) {
            var request = {} as UpdatePatientPhotoRequest;

            request.patientId = this.requestModel.patientId;
            request.base64string = this.base64img;

            try {
                this.isLoading = true;
                await this.patientDataService.updatePatientPhotoAsync(request);
            }
            finally {
                this.isLoading = false;
            }

            this.componentContext.broadcastService.next({ name: BroadCastEvents.PatientPhotoChanged, args: { src: this.base64img } });
            this.goBack();
        }
    }

    onPictureLoaded(args: any) {
        this.base64img = args.base64string;
    }
}
